/**
 * BusinessUnit Validation Schemas
 */

import { z } from 'zod';
import { nameField, optionalBoundedText } from './shared';

export const createBusinessUnitSchema = z.object({
  name: nameField(200, 'Name is required', 'Name must be 200 characters or less'),
  description: optionalBoundedText(2000),
  unitType: z.enum(['division', 'group', 'team', 'partner'], { message: 'Unit type is required' }),
  lifecycleStatus: z.enum(['active', 'inactive', 'merged', 'disbanded']).optional(),
  parentBusinessUnitId: z.string().optional(),
  code: optionalBoundedText(100),
  tags: z.array(z.string().min(1)).optional().default([]),
});

export type CreateBusinessUnitFormData = z.infer<typeof createBusinessUnitSchema>;
